@if (mode() === 'list') {
  <div class="list-container">
    <form [formGroup]="filters" class="list-search-row">
      <mc-input
        class="search-bar"
        hiddenlabel
        label="Search OEM discounts"
        placeholder="Search by code or manufacturer name"
        fit="small"
        icon="magnifying-glass"
        formControlName="searchText"
        (keyup.enter)="search()">
      </mc-input>
    </form>

    <div class="pure-g m-t-16 actions-row">
      @if (canAdd) {
        <mc-button
          appearance="primary"
          fit="small"
          (click)="addNew()"
          (keydown.enter)="addNew()"
          (keydown.space)="$event.preventDefault(); addNew()">
          Add New
        </mc-button>
      }
    </div>

    <div class="m-t-8 quick-filter-box">
      <div class="applied-filter-holder">
        @if (filters.controls.partManufacturerCodeList.value.length) {
          <div class="filter-label">Manufacturer Code</div>
          <app-tag-with-overflow
            [data]="filters.controls.partManufacturerCodeList.value"
            [overflowCount]="appliedFilterOverflowCount"
            [withaction]="true"
            [dismiss]="removePartManufacturerCodeFilter()">
          </app-tag-with-overflow>
        }
        @if (filters.controls.nameList.value.length) {
          <div class="filter-label">Manufacturer Name</div>
          <app-tag-with-overflow
            [data]="filters.controls.nameList.value"
            [overflowCount]="appliedFilterOverflowCount"
            [withaction]="true"
            [dismiss]="removeManufacturerNameFilter()">
          </app-tag-with-overflow>
        }
        @if (hasAppliedFilters) {
          <mc-button
            class="clear-btn"
            appearance="primary"
            variant="plain"
            fit="small"
            (click)="clearFilters()"
            (keydown.enter)="clearFilters()"
            (keydown.space)="$event.preventDefault(); clearFilters()">
            Clear All
          </mc-button>
        }
      </div>
      <div class="utility-buttons">
        <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">
          <mc-button
            class="utility-button-no-round"
            slot="trigger"
            appearance="neutral"
            variant="filled"
            icon="sliders-horizontal"
            hiddenlabel
            label="Filters"
            fit="medium"
            (click)="filtersOpen = true"
            (keydown.enter)="filtersOpen = true"
            (keydown.space)="$event.preventDefault(); filtersOpen = true">
          </mc-button>
          <span>Filters</span>
        </mc-tooltip>
        @if (authPolicies.canViewOemDiscount) {
          <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">
            <mc-button
              class="utility-button"
              slot="trigger"
              appearance="neutral"
              variant="filled"
              icon="tray-arrow-down"
              hiddenlabel
              label="Download"
              fit="medium"
              [loading]="isDownload"
              (click)="onDownload()"
              (keydown.enter)="onDownload()"
              (keydown.space)="$event.preventDefault(); onDownload()">
            </mc-button>
            <span>Download</span>
          </mc-tooltip>
        }
      </div>
    </div>

    <div class="table-container m-t-12">
      @if (loading) {
        <div class="aems-card">Loading OEM discounts...</div>
      } @else if (data.length) {
        <mc-table
          [data]="data"
          [columns]="columns"
          fit="small"
          nowrap="true"
          sortmanual
          sortdefaultdirection="ascending"
          tabularFigures="true"
          headersticky
          height="100%"
          (sortchange)="onSort($event)">
          @for (row of data; track row.id) {
            <div slot="{{ row.id }}_partManufacturerCode">
              <a class="code-link" [routerLink]="['/master-data/shop-contract/oem-discount', row.partManufacturerCode]">
                {{ row.partManufacturerCode }}
              </a>
            </div>
          }
        </mc-table>
      } @else {
        <div class="aems-card">No OEM discounts found. To widen your search, change or remove filters.</div>
      }
    </div>

    @if (data.length) {
      <app-pagination
        [currentPage]="currentPage"
        [lastPage]="lastPage"
        [totalRecords]="totalRecords"
        [pageLimit]="pageLimit"
        [showCountOnly]="true"
        (pageChange)="pageChanged($event)"
        (pageSizeChange)="pageSizeChanged($event)">
      </app-pagination>
    }
  </div>

  <mc-modal heading="Filters" fit="small" dimension="large" [open]="filtersOpen" (closed)="filtersOpen = false">
    <form [formGroup]="filters" class="pure-g">
      <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
        <mc-multi-select
          ngDefaultControl
          label="Manufacturer Code"
          fit="medium"
          placeholder="Select manufacturer codes"
          formControlName="partManufacturerCodeList">
          @for (option of options; track option.key) {
            <mc-option [value]="option.key">{{ option.key }}</mc-option>
          }
        </mc-multi-select>
      </div>
      <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
        <mc-multi-select
          ngDefaultControl
          label="Manufacturer Name"
          fit="medium"
          placeholder="Select manufacturer names"
          formControlName="nameList">
          @for (option of options; track option.key) {
            <mc-option [value]="option.value">{{ option.value }}</mc-option>
          }
        </mc-multi-select>
      </div>
    </form>
    <mc-button
      slot="secondaryAction"
      appearance="neutral"
      variant="outlined"
      (click)="clearFilters()"
      (keydown.enter)="clearFilters()"
      (keydown.space)="$event.preventDefault(); clearFilters()">
      Clear filters
    </mc-button>
    <mc-button
      slot="primaryAction"
      appearance="primary"
      (click)="applyFilters()"
      (keydown.enter)="applyFilters()"
      (keydown.space)="$event.preventDefault(); applyFilters()">
      Apply filters
    </mc-button>
  </mc-modal>
} @else if (mode() === 'detail') {
  @if (error()) {
    <div class="aems-card m-b-12">{{ error() }}</div>
  } @else if (detail(); as manufacturer) {
    <div class="m-b-12 page-header">
      <h3>{{ manufacturer.partManufacturerCode }}</h3>
      <div class="header-actions">
        @if (canEdit) {
          <mc-button
            appearance="primary"
            variant="outlined"
            fit="small"
            icon="pencil"
            (click)="edit()"
            (keydown.enter)="edit()"
            (keydown.space)="$event.preventDefault(); edit()">
            Edit
          </mc-button>
        }
        @if (canViewAuditLog) {
          <mc-button
            fit="small"
            variant="outlined"
            icon="arrow-anti-clockwise-clock"
            (click)="auditOpen = true"
            (keydown.enter)="auditOpen = true"
            (keydown.space)="$event.preventDefault(); auditOpen = true">
            Audit Log
          </mc-button>
        }
      </div>
    </div>
    <p class="mds-text--body-normal mds-neutral--weak__text-color m-b-12">
      Last updated on {{ manufacturer.updatedAt | date: "d MMM yyyy 'at' HH:mm:ss" }} by {{ manufacturer.updatedBy || 'User' }}
    </p>
    <div class="aems-card m-b-16">
      <p class="mds-content"><strong>OEM Discount Details</strong></p>
      <hr class="m-b-12" />
      <div class="pure-g">
        <div class="pure-u-1 pure-u-md-1-2 p-b-12">
          <div class="field-value">{{ manufacturer.partManufacturerCode }}</div>
          <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Manufacturer Code</div>
        </div>
        <div class="pure-u-1 pure-u-md-1-2 p-b-12">
          <div class="field-value">{{ manufacturer.name }}</div>
          <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Manufacturer Name</div>
        </div>
        <div class="pure-u-1 pure-u-md-1-2 p-b-12">
          <div class="field-value">{{ manufacturer.discountPercentage }}</div>
          <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Discount %</div>
        </div>
      </div>
    </div>
  }

  <mc-modal heading="Audit Log" fit="small" dimension="large" [open]="auditOpen" (closed)="auditOpen = false">
    @if (canViewAuditLog && auditOpen && detail()) {
      <app-master-data-audit-log
        [transactionCode]="detail()?.partManufacturerCode"
        label="Manufacturer Code"
        [auditLogFetcher]="auditLogFetcher">
      </app-master-data-audit-log>
    }
  </mc-modal>
} @else {
  <h3 class="m-b-16">{{ mode() === 'edit' ? 'Edit OEM Discount' : 'Add OEM Discount' }}</h3>

  <form [formGroup]="form">
    <div class="aems-card">
      <div class="pure-g">
        <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
          <mc-input
            ngDefaultControl
            label="Manufacturer Code"
            placeholder="Enter manufacturer code"
            formControlName="partManufacturerCode"
            [disabled]="mode() === 'edit'"
            fit="small"
            required>
          </mc-input>
        </div>
        <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
          <mc-input
            ngDefaultControl
            label="Manufacturer Name"
            placeholder="Enter manufacturer name"
            formControlName="name"
            fit="small"
            required>
          </mc-input>
        </div>
        <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
          <mc-input
            ngDefaultControl
            type="number"
            label="Discount %"
            placeholder="Enter discount percentage"
            formControlName="discountPercentage"
            fit="small"
            min="0"
            max="100"
            required>
          </mc-input>
        </div>
      </div>
    </div>
    <div class="right m-t-16">
      @if (mode() === 'edit' && canDelete) {
        <mc-button
          appearance="neutral"
          variant="outlined"
          icon="trash"
          (click)="deleteOpen.set(true)"
          (keydown.enter)="deleteOpen.set(true)"
          (keydown.space)="$event.preventDefault(); deleteOpen.set(true)">
          Delete
        </mc-button>
      }
      <mc-button
        appearance="neutral"
        variant="outlined"
        class="m-l-8"
        (click)="cancel()"
        (keydown.enter)="cancel()"
        (keydown.space)="$event.preventDefault(); cancel()">
        Cancel
      </mc-button>
      <mc-button
        appearance="primary"
        class="m-l-8"
        [loading]="submitting()"
        (click)="save()"
        (keydown.enter)="save()"
        (keydown.space)="$event.preventDefault(); save()">
        {{ mode() === 'edit' ? 'Save changes' : 'Add OEM discount' }}
      </mc-button>
    </div>
  </form>

  <mc-modal heading="Delete OEM Discount" fit="small" dimension="small" [open]="deleteOpen()" (closed)="deleteOpen.set(false)">
    <p>This OEM discount will no longer be available. Are you sure you want to delete it?</p>
    <mc-button
      slot="secondaryAction"
      appearance="neutral"
      variant="outlined"
      (click)="deleteOpen.set(false)"
      (keydown.enter)="deleteOpen.set(false)"
      (keydown.space)="$event.preventDefault(); deleteOpen.set(false)">
      Cancel
    </mc-button>
    <mc-button
      slot="primaryAction"
      appearance="primary"
      (click)="delete()"
      (keydown.enter)="delete()"
      (keydown.space)="$event.preventDefault(); delete()">
      Delete
    </mc-button>
  </mc-modal>
}
